import React, {Component} from 'react';

import { ic } from './src/c_20210415a_YSh/ic';
import { iv } from './src/c_20210415a_YSh/iv';

import iCpyList from './src/c_20210415a_YSh/iCpyList';
import iCpyDtl from './src/c_20210415a_YSh/iCpyDtl';
import iPdtList from './src/c_20210415a_YSh/iPdtList';
import iPdtDtl from './src/c_20210415a_YSh/iPdtDtl';
import iUserList from './src/c_20210415a_YSh/iUserList';
import iUserDtl from './src/c_20210415a_YSh/iUserDtl';
//import iOdrDtl from './src/iOdrDtl';
import iCmrDtl from './src/iCmrDtl';
import iCmrList from './src/iCmrList';
//import iPayDtl from './src/iPayDtl';
//import iPayList from './src/iPayList';
import iSeatList from './src/iSeatList';
import iSeatDtl from './src/iSeatDtl';
import iSrvList from './src/iSrvList';
import iSrvDtl from './src/iSrvDtl';
import iMthList from './src/iMthList';
import iMthDtl from './src/iMthDtl';
//import iRtrList from './src/iRtrList';
//import iRtrDtl from './src/iRtrDtl';
//import iDayList from './src/iDayList';
import iDayDtl from './src/iDayDtl';
//import iRslList from './src/iRslList';
import iPdtCtgList from './src/c_20210415a_YSh/iPdtCtgList';
import iPdtCtgDtl from './src/c_20210415a_YSh/iPdtCtgDtl';
import cLgn from './src/c_20210415a_YSh/cLgn';

import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';

/*
import { StyleSheet, Text, View } from 'react-native';

export default function App() {
  return (
    <View style={styles.container}>
      <Text>Hello World!</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
*/

const config = {
  screens: {
  }
};

const linking = {
  prefixes: [ic.g_url0],
//    config,
};

const Stack = createStackNavigator();

function App() {

  // NavigationContainer に linking を指定すると url に query parameters が 表示される模様
  return (
    <NavigationContainer
        linking={linking}
    >
      <Stack.Navigator
          initialRouteName='cLgn'
      >
        <Stack.Screen
          name='cLgn'
          component={cLgn}
          initialParams={{}}
          options={{
            title: 'ログイン',
            headerShown: false, 
          }}
        />
        <Stack.Screen
          name='iCpyList'
          component={iCpyList}
          initialParams={{}}
          options={{
            title: '店舗一覧',
            headerShown: false, 
          }}
        />
        <Stack.Screen
          name='iCpyDtl'
          component={iCpyDtl}
          initialParams={{}}
          options={{
            title: '店舗情報',
            headerShown: false, 
          }}
        />
        <Stack.Screen
          name='iPdtCtgList'
          component={iPdtCtgList}
          initialParams={{}}
          options={{
            title: '商品分類一覧',
            headerShown: false, 
          }}
        />
        <Stack.Screen
          name='iPdtCtgDtl'
          component={iPdtCtgDtl}
          initialParams={{}}
          options={{
            title: '商品分類情報',
            headerShown: false, 
          }}
        />
        <Stack.Screen
          name='iPdtList'
          component={iPdtList}
          initialParams={{}}
          options={{
            title: '商品一覧',
            headerShown: false, 
          }}
        />
        <Stack.Screen
          name='iPdtDtl'
          component={iPdtDtl}
          initialParams={{}}
          options={{
            title: '商品情報',
            headerShown: false, 
          }}
        />
        <Stack.Screen
          name='iUserList'
          component={iUserList}
          initialParams={{}}
          options={{
            title: 'スタッフ一覧',
            headerShown: false, 
          }}
        />
        <Stack.Screen
          name='iUserDtl'
          component={iUserDtl}
          initialParams={{}}
          options={{
            title: 'スタッフ情報',
            headerShown: false, 
          }}
        />
        <Stack.Screen
          name='iCmrList'
          component={iCmrList}
          options={{
//            title: '顧客一覧',
            title: '入店時刻一覧',
            headerShown: false,
          }}
        />
        <Stack.Screen
          name='iCmrDtl'
          component={iCmrDtl}
          options={{
//            title: '顧客情報',
            title: '入店時刻情報',
            headerShown: false,
          }}
        />
        <Stack.Screen
          name='iSeatList'
          component={iSeatList}
          options={{
            title: 'バインダ一覧',
            headerShown: false,
          }}
        />
        <Stack.Screen
          name='iSeatDtl'
          component={iSeatDtl}
          options={{
            title: 'バインダ情報',
            headerShown: false,
          }}
        />
        <Stack.Screen
          name='iSrvList'
          component={iSrvList}
          options={{
            title: '入席一覧',
            headerShown: false,
          }}
        />
        <Stack.Screen
          name='iSrvDtl'
          component={iSrvDtl}
          options={{
            title: '入席情報',
            headerShown: false,
          }}
        />
        <Stack.Screen
          name='iMthList'
          component={iMthList}
          options={{
            title: '月別一覧',
            headerShown: false,
          }}
        />
        <Stack.Screen
          name='iMthDtl'
          component={iMthDtl}
          options={{
            title: '月別情報',
            headerShown: false,
          }}
        />
        <Stack.Screen
          name='iDayDtl'
          component={iDayDtl}
          options={{
            title: '日別情報',
            headerShown: false,
          }}
        />
      </Stack.Navigator>
    </NavigationContainer>
  );

};

export default App;
